import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8122c3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderCardStatusesLine" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-3" }, "История статусов", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "state__pin" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "state__pinwave"
}
const _hoisted_5 = { class: "state__text" }
const _hoisted_6 = { class: "status__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (status, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "OrderCardStatusesLine__status",
        key: `status-${i}`
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["status__state", {
                    current: status.state === 'current',
                    done: status.state === 'done',
                    waiting: status.state === 'waiting',
                }])
        }, [
          _hoisted_3,
          (status.state === 'current')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.DispatcherOrderStatusesEnum[status.status]), 1)
        ], 2),
        _createElementVNode("div", _hoisted_6, _toDisplayString(status.date || 'Дата не указана'), 1)
      ]))
    }), 128))
  ]))
}